import { createApiService } from "@/core/api/apiService";
import type {
  ClientDto,
  CreateClientDto,
  UpdateClientDto,
} from "../types/clientTypes";

export function createClientApiClient() {
  const api = createApiService("clients");

  return {
    getAll: async (businessId: string, signal?: AbortSignal): Promise<ClientDto[]> => {
      return api.get<ClientDto[]>(`/?businessId=${encodeURIComponent(businessId)}`, { signal });
    },

    getById: async (id: string, signal?: AbortSignal): Promise<ClientDto> => {
      return api.get<ClientDto>(`/${encodeURIComponent(id)}`, { signal });
    },

    create: async (data: CreateClientDto): Promise<ClientDto> => {
      return api.post<ClientDto>("", data);
    },

    update: async (id: string, data: UpdateClientDto): Promise<ClientDto> => {
      return api.put<ClientDto>(`/${id}`, data);
    },

    delete: async (id: string): Promise<{ message: string }> => {
      return api.delete<{ message: string }>(`/${id}`);
    },
  };
}

const clientApiService = createClientApiClient();
export { clientApiService };
